import { render, staticRenderFns } from "./DuplicateAccounts.vue?vue&type=template&id=c0bd0172&scoped=true&"
import script from "./DuplicateAccounts.vue?vue&type=script&lang=js&"
export * from "./DuplicateAccounts.vue?vue&type=script&lang=js&"
import style0 from "./userAdmin.css?vue&type=style&index=0&id=c0bd0172&scoped=true&lang=css&"
import style1 from "./DuplicateAccounts.vue?vue&type=style&index=1&id=c0bd0172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bd0172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VPagination,VProgressCircular,VSimpleTable,VSkeletonLoader,VSnackbar,VTextField})
